import { Expose, Transform } from 'class-transformer';

import { CallType } from '../../common';
import { BaseReport } from './base-report-model';

export class CallReport extends BaseReport {
  @Expose() callId : string ;
  @Expose() HangupBy : string ;
  @Expose() duration : string ;
  @Expose() endDateTime : string ;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  startDateTime : string ;
  @Expose() status : string ;
  @Expose() studentEmail : string ;
  @Expose() studentId : string ;
  @Expose() studentName : string ;
  @Expose() teacherEmail : string ;
  @Expose() teacherId : string ;
  @Expose() teacherName : string ;
  @Expose() type : CallType ;

}
